import type { FC } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

import { AddIcon } from '@/assets';
import { OutlinedButton } from '@/shared/components/OutlinedButton';

type Props = {
  label: string;
  onPress: () => void;
  loading?: boolean;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
};

export const AddImageButton: FC<Props> = ({
  label,
  onPress,
  loading,
  disabled,
  style
}) => (
  <OutlinedButton
    icon={({ size, color }) => (
      <AddIcon fill={color} width={size} height={size} />
    )}
    onPress={onPress}
    loading={loading}
    disabled={disabled}
    style={[style]}
  >
    {label}
  </OutlinedButton>
);
